.sprite {
  display: inline-block;
  flex: none;
  background-repeat: no-repeat;
  vertical-align: middle;
}

.stack {
  position: relative;
  display: inline-block;
  flex: none;
}

.layer {
  position: absolute;
  inset: 0;
}
